import { GiReceiveMoney } from "react-icons/gi";
import { Button } from "../../components/ui/Button";
import { HiOutlineCalendar, HiOutlineCash, HiOutlineUser } from "react-icons/hi";
import { MdOutlinePercent } from "react-icons/md";
import { IoCalendar } from "react-icons/io5";

export const AdvantagesBenefitCard = ({onGoToRegister}) => (
    <div className="bg-orange-50 w-full">
        <section id="AdvantagesBenefitCard" className="bg-orange-50 py-16 px-6 max-w-7xl mx-auto text-center">
            <span className="inline-block bg-orange-100 text-orange-600 text-xs font-semibold rounded-full px-4 py-1 mb-4">
                Vantagens
            </span>

            <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 max-w-xl mx-auto leading-relaxed mb-4">
                Vantagens dos Cartões de Crédito Consignado e Crédito Consignado Benefício Bmg
            </h2>

            <p className="text-gray-600 max-w-xl mx-auto mb-12 leading-relaxed">
                Contrate os Cartões Consignado e Consignado Benefício Bmg com as taxas mais atrativas!
            </p>

            <div className="grid grid-cols-1 md:grid-cols-4 gap-6 max-w-5xl mx-auto mb-12 text-left">
                <div className="border border-gray-200 rounded-lg p-6 flex flex-col gap-2">
                    <GiReceiveMoney className="text-orange-500 w-6 h-6 mb-2" />
                    <h3 className="font-semibold text-gray-800 mb-1">Dinheiro na conta</h3>
                    <p className="text-gray-600 text-sm">
                        Saque de até 70% do limite do seu cartão a qualquer momento. Consulte as condições.
                    </p>
                </div>

                <div className="border border-gray-200 rounded-lg p-6 flex flex-col gap-2">
                    <IoCalendar className="text-orange-500 w-6 h-6 mb-2" />
                    <h3 className="font-semibold text-gray-800 mb-1">Livre de mensalidades</h3>
                    <p className="text-gray-600 text-sm">
                        Seu cartão de crédito consignado e consignado benefício com anuidade zero!
                    </p>
                </div>

                <div className="border border-gray-200 rounded-lg p-6 flex flex-col gap-2">
                    <HiOutlineCash className="text-orange-500 w-6 h-6 mb-2" />
                    <h3 className="font-semibold text-gray-800 mb-1">Taxas de juros baixas</h3>
                    <p className="text-gray-600 text-sm">
                        Aproveite taxas bem menores que cartões de crédito tradicional.
                    </p>
                </div>

                <div className="border border-gray-200 rounded-lg p-6 flex flex-col gap-2">
                    <HiOutlineUser className="text-orange-500 w-6 h-6 mb-2" />
                    <h3 className="font-semibold text-gray-800 mb-1">Benefícios exclusivos</h3>
                    <p className="text-gray-600 text-sm">
                        Seguro de vida, farmácia e funeral para aposentados e pensionistas INSS.
                    </p>
                </div>
            </div>

            <Button onClick={onGoToRegister} variant="outline">
                Contratar agora
            </Button>
        </section>
    </div>
);